import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * Matches Match Hub cards: light surfaces in light mode (no dark inset strip).
 */
export function getMatchHubLiveStatsBlockStyles(theme: Theme, isDark: boolean) {
  const panelBg = isDark ? theme.background.cardElevated : theme.background.card;
  const panelBorder = isDark ? theme.gray[300] : theme.gray[200];
  const rowDivider = isDark ? theme.gray[300] : theme.gray[200];
  const statLabelColor = isDark ? theme.gray[500] : theme.gray[600];
  const valueColor = theme.gray[900];
  const homeSegBg = isDark ? theme.white : theme.gray[200];
  const homePctColor = theme.gray[900];
  const homePillBg = isDark ? theme.white : theme.white;
  const homePillBorder = isDark ? theme.gray[200] : theme.gray[200];

  return StyleSheet.create({
    wrap: {
      marginBottom: theme.spacing.md,
      borderRadius: theme.borderRadius.xl,
      backgroundColor: panelBg,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: panelBorder,
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.lg,
      overflow: 'hidden',
    },
    possessionTrack: {
      flexDirection: 'row',
      height: 36,
      borderRadius: 18,
      overflow: 'hidden',
      marginBottom: theme.spacing.lg,
    },
    possessionSegBase: {
      justifyContent: 'center',
      paddingHorizontal: theme.spacing.md,
      minWidth: 44,
    },
    possessionHomeSeg: {
      backgroundColor: homeSegBg,
      alignItems: 'flex-start',
    },
    possessionPctHome: {
      ...theme.typography.labelSmall,
      fontWeight: '800',
      color: homePctColor,
    },
    possessionSegAway: {
      flexGrow: 1,
      flexShrink: 1,
      alignItems: 'flex-end',
    },
    possessionPctAway: {
      ...theme.typography.labelSmall,
      fontWeight: '800',
      textAlign: 'right',
    },
    statRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: theme.spacing.sm,
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: rowDivider,
    },
    statRowFirst: {
      borderTopWidth: 0,
      marginTop: theme.spacing.md,
    },
    homePill: {
      minWidth: 40,
      paddingVertical: 6,
      paddingHorizontal: theme.spacing.md,
      borderRadius: 20,
      backgroundColor: homePillBg,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: homePillBorder,
      alignItems: 'center',
      justifyContent: 'center',
    },
    homePillText: {
      ...theme.typography.labelSmall,
      fontWeight: '800',
      color: valueColor,
    },
    statLabel: {
      flex: 1,
      ...theme.typography.caption,
      fontWeight: '500',
      color: statLabelColor,
      textAlign: 'center',
      paddingHorizontal: theme.spacing.sm,
    },
    awayValue: {
      minWidth: 40,
      ...theme.typography.labelSmall,
      fontWeight: '700',
      color: valueColor,
      textAlign: 'right',
    },
  });
}

export type MatchHubLiveStatsBlockStyles = ReturnType<typeof getMatchHubLiveStatsBlockStyles>;
